import React, { useContext } from 'react';
import cn from 'classnames';
import styles from './style.module.scss';
import { Typography } from '../../typography-voery/Typography';
import { ListContext } from './context';
import { CheckIcon } from 'src/onboarding/assets/icons/CheckIcon';

interface ListOptionProps {
  children: React.ReactNode;
  value: string;
  className?: string;
}

export const ListOption: React.FC<ListOptionProps> = ({ children, value, className }) => {
  const { handleChange, currentValue } = useContext(ListContext);
  const isActive = currentValue === value;

  return (
    <div
      className={cn(styles.option, { [styles.optionActive]: isActive }, className)}
      onClick={() => handleChange(value)}
    >
      <Typography variant='body-semibold' className={styles.optionText}>
        {children}
      </Typography>
      {isActive && <CheckIcon className={styles.checkIcon} />}
    </div>
  );
};
